import request from "@/utils/request";
import {IJobPositionModel} from "./types";

export const defaultJobPositionData: IJobPositionModel = {
    id: "",
    name: "",
    createdAt: ""
};

export const getJobPositionList = () =>
    request({
        url: "/job-positions",
        method: "get"
    });

export const createJobPosition = (data: any) =>
    request({
        url: "/job-positions",
        method: "post",
        data
    });

export const updateJobPosition = (id: string, data: any) =>
    request({
        url: `/job-position/${id}`,
        method: "put",
        data
    });

export const deleteJobPosition = (id: string) =>
    request({
        url: `/job-position/${id}`,
        method: "delete"
    });
